import React, { useState } from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Heading,
} from '@chakra-ui/react';
import AdminLayout from '../layout/AdminLayout';
import PresenterPhotoManager from '../PresenterPhotoManager';
import { useLogout } from '../utils/authUtils';

const MediaManagerPage: React.FC = () => {
  // Authentication
  const { handleLogout } = useLogout();

  // Methodist brand colors
  const methodistBlue = '#0066CC';
  const methodistNavy = '#002D72';
  
  return (
    <AdminLayout 
      title="Media Manager - Manage presentation media assets"
      onLogout={handleLogout}
    >
      <Heading size="lg" mb={6} color={methodistNavy}>Media Management</Heading>
      
      <Tabs variant="enclosed" colorScheme="blue" isLazy>
        <TabList mb={4}>
          <Tab _selected={{ color: 'white', bg: methodistBlue }} fontWeight="medium">Logo</Tab>
          <Tab _selected={{ color: 'white', bg: methodistBlue }} fontWeight="medium">Presenter Photo</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Box p={4} borderWidth="1px" borderRadius="md" bg="white">
              <Heading size="md" mb={4} color={methodistNavy}>Logo Management</Heading>
              {/* Logo Management Component would go here */}
              <Box p={4} bg="gray.50" borderRadius="md">
                <p>Logo management functionality will be implemented here.</p>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel>
            <Box p={4} borderWidth="1px" borderRadius="md" bg="white">
              <Heading size="md" mb={4} color={methodistNavy}>Presenter Photo Management</Heading>
              <PresenterPhotoManager />
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </AdminLayout>
  );
};

export default MediaManagerPage;
